import { io, Socket } from 'socket.io-client';
import SocketState from '../../context/socket/state';
import SocketEvents from './events';

export default class SocketService {
  socketInstance: Socket;
  socketEvent: SocketEvents;

  constructor(
    setValue: React.Dispatch<React.SetStateAction<SocketState>>,
    token: string
  ) {
    const authorization = `Bearer ${token}`;

    this.socketInstance = io(`${process.env.REACT_APP_API_BASE_URL}`, {
      transports: ['websocket', 'polling'],
      extraHeaders: {
        Authorization: authorization
      },
      transportOptions: {
        polling: {
          extraHeaders: {
            Authorization: authorization
          }
        },
        websocket: {
          extraHeaders: {
            Authorization: authorization
          }
        }
      }
    });

    this.socketEvent = new SocketEvents(this, setValue);
  }
}
